export const TitleTranslation = () => {
  const lang = localStorage.getItem("lang")
  if (lang === "uz") {
    return "titleUZ"
  }
  if (lang === "ru") {
    return "titleRU"
  }
  if (lang === "уз") {
    return "title"
  }
  if (lang === "en") {
    return "titleEN"
  }
}
